<template>
<div class="chapter">
<div class="inner_page">
<p class="centerb1"><a id="page_ii"></a><em class="italic">Also from the Emerging Civil War 10th Anniversary Series …</em></p>
<div class="img_container">
<img alt="Images" src="images/f0002-1.jpg"/>
</div>
<p class="capc"><em class="italic">Civil War Monuments and Memory</em> and <em class="italic">The Civil War in Pop Culture</em> make perfect companion volumes. We hope you’ll read the books in conversation with each other for a fuller understanding of the ways that history and historical memory interrelate.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Adcard1.vue?20640bb1